<!--A modification using max height based on https://github.com/orlyyani/read-more-->
<template>
	<div class="container-div">
		<div ref="text" :class="dataClass" :style="{height: computedHeight, display: isDisplayed, position: 'relative', overflow: 'hidden'}">
			<slot></slot>
			<div v-if="!isReadMore && originalHeight > maxHeight" class="read-more-gradient-overlay" ></div>
		</div>
		<div v-show="this.originalHeight > maxHeight" :style="calculateMargin">
			<a role="button" :class="this.arrowStyle !== 'right' ? 'read ' : 'cursorChange'" @click="toggleReadMore()">
				<span class="read-more-text">{{ !isReadMore ? $t('general.readMore') : $t('general.readLess') }}</span>
				<span>
					<img
						:src="require('../../images/Plus.svg')"
						class="read-more-icon"
						:class="{ opened: isReadMore}"
						alt="open-close"
					/>
				</span>
			</a>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		maxHeight: {
			type: Number,
			default: 384
		},
		margin: Number,
		grayblock: Boolean,
		display: Boolean,
		arrowStyle: String
	},
	data() {
		return {
			isReadMore: false,
			originalHeight: null
		};
	},
	computed: {
		calculateMargin() {
			if (!this.margin) return "";
			else {
				return "margin-top: " + this.margin + "px;";
			}
		},
		isDisplayed() {
			return !this.isReadMore && this.display ? "none" : "block";
		},
		computedHeight() {			
			if (this.originalHeight > this.maxHeight && !this.isReadMore) {				
				var newHeight = (this.maxHeight - (this.maxHeight % 1));
				if (newHeight < 0) {
					newHeight = 0;
				}
				return newHeight + "px";
			}
			return "100%";
		},
		dataClass() {
			return this.grayblock && this.isReadMore ? "is-gray-block data-clean text-content" : "data-clean text-content";
		}
	},
	mounted() {
		this.initReadMore();		
	},
	methods: {
		initReadMore(){
			this.originalHeight = this.$refs.text.clientHeight;
			if (this.display) this.originalHeight = this.maxHeight + 1;
		},
		toggleReadMore() {
			this.isReadMore = !this.isReadMore;
			this.$emit("toggle", this.isReadMore);
		}
	}
};
</script>
<style lang="less" scoped>
#app {
	div.data-clean {
		overflow: hidden;
	}

	a.read {
		color: #000 !important;
		background-repeat: no-repeat;
		cursor: pointer;
		background-size: 18px 18px;
		display: block;
		transition: transform 0.2s;
		padding-top: 16px;
		display: flex;
		flex-direction: row;
		gap: 8px;
	}

	.read-more-gradient-overlay {				
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 80px;
		background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, #fff 100%);		
	}

	.readMore {
		background-image: url(/arrowdown.png);
	}

	.readLess {
		background-image: url(/arrowup.png);
	}
	.cursorChange {
		cursor: pointer;
	}

	.read-more-text {
		font-size: 16px;
		line-height: 24px;
		font-weight: 700;
		color: #351FB7;
	}

	.read-more-icon {
		transition: transform 0.2s;
		width: 24px;
		height: 24px;
	}

	.read-more-icon.opened {
		transform: rotate(45deg);
	}	
}
</style>
<style lang="less">
#app {
	.is-gray-block {
		overflow-x: auto !important;
		padding: 5px 15px;
		background-color: #f2f2f2;
		margin-bottom: 12px !important;
	}

	.is-gray-block > div {
		padding: 5px 0px;
	}

	.is-gray-block .data-title h3 {
		font-size: 16px;
		line-height: 24px;
		font-weight: 700;
		color: #25167A;
		margin-bottom: 0px;
	}
}
</style>